export const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};


export const isValidPhoneNumber = (phone: string) => {
    return phone.length === 10;
};

export const isVinaphoneNumber = (phone: string) => {
    const vinaphonePrefixes = ["091", "094", "088", "083", "084", "085", "081", "082"];
    return vinaphonePrefixes.some((prefix) => phone.startsWith(prefix));
};